import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';

interface PasswordRequirementsProps {
  password: string;
  className?: string;
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password = '',
  className = '',
}) => {
  const hasLength = password.length >= 8;
  const hasUpper = /[A-Z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);

  const requirements = [
    { label: 'At least 8 characters', met: hasLength },
    { label: 'Includes uppercase letter (A-Z)', met: hasUpper },
    { label: 'Includes digit / number (0-9)', met: hasDigit },
    { label: 'Includes special character (!@#$...)', met: hasSpecial },
  ];

  const metCount = requirements.filter((r) => r.met).length;

  return (
    <div className={`p-3 bg-slate-50 border border-slate-200 rounded-xl space-y-2 text-xs ${className}`}>
      <div className="flex items-center justify-between">
        <span className="font-semibold text-slate-700">Password Requirements</span>
        <span className={`font-medium ${metCount === 4 ? 'text-emerald-600' : 'text-slate-500'}`}>
          {metCount}/4 met
        </span>
      </div>

      <div className="space-y-1.5">
        {requirements.map((req, index) => (
          <div key={index} className="flex items-center gap-2">
            {req.met ? (
              <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0" />
            ) : (
              <Circle className="w-4 h-4 text-slate-300 shrink-0" />
            )}
            <span className={req.met ? 'text-emerald-700 font-medium' : 'text-slate-500'}>
              {req.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
